import { Button, Form, Input, InputNumber, Popconfirm, Select } from "antd";

import styles from "./TermForm.module.css";
import ClassTimeTable from "../ClassTimeTable/ClassTimeTable";
import { useState } from "react";
import { useEffect } from "react";
import { DatePicker } from "antd-jalali";
import dayjs from "dayjs";
import useLevels from "../../hooks/useLevels";
const { Option } = Select;
const TermForm = ({
  onSubmit,
  loading,
  disabled,
  EditButton,
  editMode,
  ToggleEditMode,
  initialValues,
  newTerm,
  newTermForm,
  deleteTerm,
  sendTerm,
  levels
}) => {
  const [form] = Form.useForm();
  const [classTime, setClassTime] = useState(null);

  useEffect(() => {
    let class_time = [];
    if (initialValues) {
      if (initialValues.days && initialValues.times) {
        for (let i = 0; i < initialValues.days.length; i++) {
          for (let j = 0; j < initialValues.times.length; j++) {
            if (i === j) {
              class_time.push({
                time: initialValues.times[i],
                day: initialValues.days[j],
              });
            }
          }
        }
        setClassTime(class_time);
      } else {
        setClassTime([]);
      }
    }
  }, []);

  const initialValuesNormalized = initialValues
    ? {
        ...initialValues,
        class_time: classTime,
        start_date : initialValues.start_date ? dayjs(initialValues.start_date) : null
      }
    : {};

  return (
    <>
      <EditButton
        loading={loading}
        submit={form.submit}
        editMode={editMode}
        ToggleEditMode={ToggleEditMode}
        onCancel={() => {
          form.setFieldsValue(initialValuesNormalized);
        }}
      />
      {classTime || newTermForm ? (
        <Form
          className={styles.SignUpFormData}
          initialValues={initialValuesNormalized}
          disabled={disabled}
          layout="vertical"
          form={newTermForm ? newTermForm : form}
          name="register"
          onFinish={onSubmit}
          scrollToFirstError
        >
          <div className={styles.DataContainer}>
            <div className={styles.RightSide}>
              <Form.Item name="teacher_name" label="نام معلم">
                <Input
                  style={{ width: "100%" }}
                  placeholder="نام معلم را وارد کنید:"
                />
              </Form.Item>
              <Form.Item name="supervisor_name" label="نام سوپروایزر">
                <Input
                  style={{ width: "100%" }}
                  placeholder="نام سوپروایزر را وارد کنید:"
                />
              </Form.Item>
              <Form.Item name="class_time" label="زمان بندی کلاس">
                <ClassTimeTable
                disabled={disabled}
                  setValue={(value) => {
                    if (newTermForm) {
                      newTermForm.setFieldValue("class_time", value);
                    } else {
                      form.setFieldValue("class_time", value);
                    }
                  }}
                />
              </Form.Item>
            </div>
            <div className={styles.RightSide}>
              <Form.Item name="session_count" label="تعداد جلسات">
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder=":تعداد جلسات را وارد کنید"
                  defaultValue={10}
                  min={1}
                />
              </Form.Item>

              <Form.Item label="سطح زبان آموز">
                <Input.Group compact style={{ display: "flex", width: "100%" }}>
                  <Form.Item name="level" noStyle>
                    <Select
                      style={{ width: "50%" }}
                      placeholder="سطح زبان را انتخاب کنید:"
                    >
                     {Array.isArray(levels) && levels.map((level)=>{
                      return <Option value={level.value}>{level.text}</Option>
                    })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="proficiency" noStyle>
                    <Select
                      style={{ width: "50%" }}
                      placeholder="کیفیت سطح زبان را انتخاب کنید:"
                    >
                      <Option value={1}>ضعیف</Option>
                      <Option value={2}>متوسط</Option>
                      <Option value={3}>خوب</Option>
                    </Select>
                  </Form.Item>
                </Input.Group>
              </Form.Item>
              <Form.Item name="description" label="توضیحات">
                <Input.TextArea
                  placeholder="توضیحات"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item name="start_date" label="تاریخ شروع اولین کلاس">
                  <DatePicker style={{width : '100%'}} />
              </Form.Item>
            </div>
          </div>
        </Form>
      ) : null}
      {sendTerm ? (
        <Popconfirm
          title="آیا میخواهید کلاس را به کاربر اطلاع دهید؟"
          onConfirm={sendTerm}
        >
          <Button
            style={{ marginLeft: "1rem" }}
            loading={loading}
  
            disabled={false}
          >
            اطلاع رسانی کلاس
          </Button>
        </Popconfirm>
      ) : null}
      {deleteTerm ? (
        <Popconfirm
          title="آیا میخواهید کلاس را حذف کنید؟"
          onConfirm={deleteTerm}
        >
          <Button loading={loading}  danger disabled={false}>
            حذف کلاس
          </Button>
        </Popconfirm>
      ) : null}
    </>
  );
};

export default TermForm;
